import React from 'react';
import { COMPANY_INFO } from '../data/content';

const Footer = () => {
  return (
    <footer className="bg-neutral-darkNavy text-white py-8 border-t border-white/10">
      <div className="container mx-auto px-4 flex flex-col md:flex-row justify-between items-center">
        <div className="mb-4 md:mb-0">
          <span className="text-2xl font-bold tracking-tighter">Tip-Top</span>
          <span className="text-gray-500 text-sm ml-2">© {new Date().getFullYear()} Sva prava zadržana.</span>
        </div>
        
        <div className="flex gap-6 text-sm text-gray-400">
          <a href="#" className="hover:text-primary-orange transition-colors">Politika Privatnosti</a>
          <a href="#" className="hover:text-primary-orange transition-colors">Uslovi Korišćenja</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
